import { ValidateOperatorTypeDescription } from 'models';

export const isValidByOperator = <T>(value: T, valueToCompare: T, operator: ValidateOperatorTypeDescription): boolean => {
    switch (operator) {
        case ValidateOperatorTypeDescription.EqualTo: {
            return value === valueToCompare;
        }

        case ValidateOperatorTypeDescription.LessThan: {
            return value < valueToCompare;
        }

        case ValidateOperatorTypeDescription.MoreThan: {
            return value > valueToCompare;
        }

        case ValidateOperatorTypeDescription.MoreThanOrEqualTo: {
            return value >= valueToCompare;
        }

        case ValidateOperatorTypeDescription.LessThanOrEqualTo: {
            return value <= valueToCompare;
        }

        default:
            return false;
    }
};